var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('NavBar',{attrs:{"fixed":true,"title":_vm.$t('mine.serviceTools.inviteTask'),"left-arrow":"","placeholder":""},on:{"click-left":function($event){return _vm.$router.go(-1)}}}),_c('JList',{staticClass:"list_wrap",attrs:{"list":"","tabBottomBorder":"","request":false,"customList":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }